export { SchemaEditorActions } from './schemas.actions';
export {
  SCHEMAS_FEATURE_KEY,
  SchemasEditorState,
  schemasReducer,
  selectProductSchemaTypes,
  selectSchemas,
  selectSchemasError,
  selectSchemasLoading,
  selectSchemaViewBySid,
  selectSelectedSchema,
} from './schemas.reducer';

import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { SchemasEditorFeature } from './schemas.reducer';
import { SchemasEditorEffects } from './shcemas.effects';

@NgModule({
  providers: [
    provideState(SchemasEditorFeature),
    provideEffects(SchemasEditorEffects),
  ],
})
export class SchemasStoreModule {}
